import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { CTAButton } from 'shared-components/buttons/cta-button';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import SharedIntlProviderHOC from '../shared-components/hocs/sharedIntlProviderHOC';

class OvertimeErrorModal extends React.Component {
  constructor (props, context) {
    super(props, context);

    this.clickAction = this.clickAction.bind(this);
  }

  getModalDetails (error) {
    const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();
    const modals = {
      OT_ALREADY_SUBMITTED: {
        errorMsg: this.props.intl.formatMessage({ id: 'inbox_bookingID_overtime.overtime_error_modal.already_submitted', defaultMessage: 'You’ve already submitted overtime charges' }),
        bodyText: <p>
          <FormattedMessage
            id='inbox_bookingID_overtime.overtime_error_modal.make_changes'
            defaultMessage='If you need to make any changes please contact our support team {link}'
            values={{
              link: (
                <a target="_blank" className="underline" href={`https://support.peerspace.com/hc/${zendeskLocale}/requests/new`}>
                  <FormattedMessage
                    id="inbox_bookingID_overtime.overtime_error_modal.here"
                    defaultMessage="here"
                  />
                </a>
              )
            }}
          />
        </p>
      },
      OT_REQUEST_OUTSIDE_TW: {
        errorMsg: this.props.intl.formatMessage({ id: 'inbox_bookingID_overtime.overtime_error_modal.cant_submit', defaultMessage: 'Sorry, you can’t submit overtime charges' }),
        bodyText: <p>
          <FormattedMessage
            id='inbox_bookingID_overtime.overtime_error_modal.can_submit'
            defaultMessage='You can only submit charges within 72 hours after the booking.'
          />
        </p>
      }
    };
    const genericError = {
      errorMsg: this.props.intl.formatMessage({ id: 'inbox_bookingID_overtime.overtime_error_modal.cant_submit_generic', defaultMessage: 'Sorry, you can’t submit overtime charges' }),
      bodyText: <p>
        <FormattedMessage
          id='inbox_bookingID_overtime.overtime_error_modal.make_changes_generic'
          defaultMessage='If you need to make any changes please contact our support team {link}'
          values={{
            link: (
              <a target="_blank" className="underline" href={`https://support.peerspace.com/hc/${zendeskLocale}/requests/new`}>
                <FormattedMessage
                  id="inbox_bookingID_overtime.overtime_error_modal.here"
                  defaultMessage="here"
                />
              </a>
            )
          }}
        />
      </p>
    };
    return modals[error] || genericError;
  }

  clickAction () {
    const { bookingID } = this.props;
    this.context.router.push({ pathname: `/inbox/${bookingID}` });
  }

  render () {
    const modalDetails = this.getModalDetails(this.props.overtimeError);
    return (
      <BootstrapModal
        {...this.props}
        body={ modalDetails.bodyText }
        bodyClass="text-center"
        modalSize="sm-size"
        modalClass="overtime-error-modal"
        onClose={this.clickAction}
        header={ <h3>{ modalDetails.errorMsg || <FormattedMessage id='inbox_bookingID_overtime.overtime_error_modal.something_wrong' defaultMessage='Something went wrong' /> }</h3> }
        footer={
          <CTAButton
            buttonText={ this.props.intl.formatMessage({ id: 'inbox_bookingID_overtime.overtime_error_modal.okay', defaultMessage: 'Okay' }) }
            classNameString="btn btn-lg btn-primary form"
            onClickAction={ this.clickAction }
            isDisabled={ false }
          />
        }
      />
    );
  }
}

OvertimeErrorModal.propTypes = {
  errorMsg: PropTypes.string,
  bodyText: PropTypes.string,
  bookingID: PropTypes.string,
  overtimeError: PropTypes.string,
  intl: intlShape
};

OvertimeErrorModal.contextTypes = {
  router: PropTypes.object
};

exports.OvertimeErrorModal = injectIntl(OvertimeErrorModal);
